<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">

  <div class="columnnbv1">
    <div class="position-fixed-scans2 border-right2  height-100pe">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-right-0px">
        <!--<div class="row"></div>-->
        <div class="card height-100vh">
          <div class="card-header wh-header border-bottom padding-bottom-0px">
            <div class="row">
              <div class="col-md-12">
                <label class="margin-bottom-0px">Patient Details</label>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row border-bottom-2px">
              <!--<div class="padding-left-14px padding-right-14px padding-bottom-14px"></div>-->
              <!--<div class="card"></div>-->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <img class="img-circle-50" src='dummy.jpg' onError="this.src='dummy.jpg';">
                    <!--<img class="img-circle-50" src="DR SITARAM.jpg" onError="this.src='dummy.jpg';">-->
                  </div>
                </div>
                <div class="row margin-left-zero margin-top-10">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px" *ngIf="Laborderdata">{{Laborderdata.PatientName}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px" *ngIf="Laborderdata">{{Laborderdata.Gender}}/{{Laborderdata.AgeYears}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px" *ngIf="PatientFormttedCode">{{PatientFormttedCode}}</label>
                  </div>

                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px" *ngIf="Laborderdata">{{Laborderdata.Telephone1}}</label>
                  </div>

                </div>

              </div>
            </div>




          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="columnnbv2-new  margin-top-17px">
    <div class="card height-100vh ">
      <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-top-0px">
        <div class="row border-bottom padding-bottom-3px margin-left-0px margin-right-0px padding-top-3px bk-lt-gray">
          <div class="col-md-3 padding-right-0px">
            <div class="row font-size-16px">
              <div class="col-md-5 padding-right-4px text-align-right">
                <label class="font-weight-bold font-size-12px margin-bottom-0px">Lab Order Dt </label>
              </div>-
              <div class="col-md-4 padding-right-0px padding-left-3px text-align-left">
                <label class="font-weight-bold font-size-12px margin-bottom-0px color-Assign" *ngIf="Laborderdata">{{Laborderdata.EffectiveOrderDate| date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2 padding-left-0px padding-right-0px">
            <div class="row font-size-16px">
              <div class="col-md-6   padding-right-2px padding-left-10px text-align-right">
                <label class="font-weight-bold font-size-12px margin-bottom-0px">Order Code </label>
              </div>-
              <div class="col-md-3 padding-right-0px padding-left-7px text-align-left">
                <label class="font-weight-bold font-size-12px margin-bottom-0px color-Assign" *ngIf="Laborderdata">{{Laborderdata.LabOrderCode}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2 padding-left-0px padding-right-0px">
            <div class="row font-size-16px">
              <div class="col-md-4  padding-right-10px text-align-right">
                <label class="font-weight-bold font-size-12px margin-bottom-0px">Branch </label>
              </div>-
              <div class="col-md-6 padding-right-0px padding-left-10px text-align-left">
                <label class="font-weight-bold font-size-12px margin-bottom-0px color-Assign" *ngIf="Laborderdata">{{Laborderdata.FacilityName}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2 padding-left-0px padding-right-0px">
            <div class="row font-size-16px">
              <div class="col-md-4  padding-right-10px text-align-right">
                <label class="font-weight-bold font-size-12px margin-bottom-0px">Doctor </label>
              </div>-
              <div class="col-md-6 padding-right-0px padding-left-10px text-align-left">
                <label class="font-weight-bold font-size-12px margin-bottom-0px color-Assign" *ngIf="Laborderdata">{{Laborderdata.PrimaryDoctor}}</label>
              </div>
            </div>
          </div>


        </div>

      </div>
      <div class="card-body  padding-bottom-0px padding-left-0px padding-right-0px padding-top-10px">


        <!--<div class="row">
          <div class="col-md-12">
            <div class="table-component margin-bottom-0px">
              <div class="table-responsive overflow-x">


                <table class="table table-striped margin-left-20p table-fixed"
                       cols="auto,2*,*,*,*,*,*,*">

                  <thead class="">
                    <tr>

                      <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                        #
                      </th>


                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                        Service Description
                      </th>
                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                        QTY
                      </th>

                      <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                        Unit Price
                      </th>

                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                        Discount
                      </th>

                      <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                        Item Rate
                      </th>

                      <th class="padding-top-4px padding-bottom-4px th-sticky">

                      </th>






                    </tr>
                  </thead>





                </table>
              </div>
            </div>
          </div>
        </div>-->
        <!--<div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="card">


              <div class="card-header wh-header border-bottom padding-bottom-0px">
                <div class="row border-bottom">
                  <div class="col-md-12">
                    <label class="margin-bottom-0px">Payment</label>
                  </div>

                </div>
              </div>
              <div class="card-body padding-top-5px padding-bottom-0px">
                <div class="row">

                    <div class="col-md-12 padding-right-0px">
                      <div class="table-component">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero width-100">

                            <thead class="">
                              <tr>

                                <th class="min-width-0px"></th>
                                <th class="th-width-170px">Amount</th>

                                <th class="th-width-170px">Charges</th>
                                <th class="th-width-170px">Ref.No</th>
                                <th>Details</th>
                              </tr>
                            </thead>
                            <tbody class="table-body">

                              <tr>
                                <td class="td-padding">

                                    <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                           [(ngModel)]="cash" />
                                    <i class="input-helper"></i>

                                    <label class="margin-bottom-0px position-absoulte margin-top-2px">Cash</label>



                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cash">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="card" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Card</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="card">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">


                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="cheque" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Cheque</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="cheque">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="demanddraft" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Demand Draft</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="demanddraft">
                                </td>



                              </tr>
                              <tr>
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="paytm" />
                                  <i class="input-helper"></i>
                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">Paytm</label>

                                </td>
                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">
                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">
                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">

                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" *ngIf="paytm">
                                </td>



                              </tr>
                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>

                </div>
                                       </div>






            </div>
          </div>
        </div>-->
        <!--  -->
        <!--<div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-80pe">
          <div class="row padding-top-3px">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-10px table-fixed"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                          #
                        </th>


                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Service Description
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          QTY
                        </th>

                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                          Unit Price
                        </th>
                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                          Item Total
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Disc %
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Net
                        </th>


                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Refund QTY
                        </th>






                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentRefundItemsController;let i = index">


                        <td class="td-padding-tb">
                          {{i+1}}
                        </td>
                        <td class=" td-padding-tb">{{l.ItemDescription}}</td>

                        <td class="text-align-center td-padding-tb">

                          <label class="margin-bottom-0px">{{l.Quantity}}</label>


                        </td>
                        <td class="text-align-center td-padding-tb padding-right-0px">{{l.UnitPrice}}</td>
                        <td class="td-padding-tb text-align-center padding-right-0px"> <label class="margin-bottom-0px">{{l.Quantity * l.UnitPrice}}</label></td>
                        <td class="td-padding-tb text-align-center max-width-10pe">


                          <label class="margin-bottom-0px">{{l.Discount}}</label>

                        </td>
                        <td class="text-align-center td-padding-tb padding-right-0px padding-left-0px">{{l.Net}}</td>
                        <td class=" td-padding-tb text-align-center td-width-10px">

                          <label *ngIf="!l.IsSelected" class="margin-bottom-0px">{{l.RefundQuantity}}</label>


                        </td>



                      </tr>
                    </tbody>



                  </table>
                </div>
              </div>
            </div>
          </div>



          <div class="row margin-left-0px" *ngIf="RefundRequestStatus=='Pending'">
            <div class="col-md-12">
              <div>
                <label class="margin-bottom-0px margin-top-5px">Comments </label>
              </div>
              <div class="form-group margin-bottom-0px">


                <textarea class="form-control3 col-md-11" rows="2" placeholder="Comments"
                          [(ngModel)]="Comments" required></textarea>


              </div>
            </div>
          </div>

          <div class="row col-md-12 margin-top-10">
            <div class="col-md-12" *ngIf="RequestMode=='Management Approval'">
              <div class="row offset-md-5">

                <button type="button" (click)="Approve()" class="btn actions-btn-prime  font-size-13px margin-right-5px" *ngIf="RefundRequestStatus=='Pending'">Approve</button>
                <button type="button" (click)="Reject()" class="btn actions-btn-prime  font-size-13px margin-right-5px" *ngIf="RefundRequestStatus=='Pending'">Reject</button>


              </div>




            </div>
          </div>


        </div>-->
        <div class="row margin-left-0px">
          <div class="col-md-12">
            <!--<label class="margin-bottom-0px color-Assign font-size-18px font-weight-bold">Specimen Collection</label>-->
            <a class="nav-link-hand color-Assign font-size-18px font-weight-bold" title="Back To Specimen Collection" (click)="BackToProfile()"><i class="fas fa-angle-double-left font-size-18px nav-link-hand"></i> Specimen Collection</a>
          </div>
        </div>
        <div class="row margin-left-20p margin-right-20p margin-top-20px" *ngFor="let l of LabSpecimens; trackBy: trackBySpecimen">
          <div class="col-md-11">
            <div class="accordion" [id]="'accordionExample'+l.LabType">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" [id]="'headingOne'+l.LabType">
                  <div class="row">
                    <div class="col-md-4">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" attr.data-target="#collapseOne{{l.LabType}}" aria-expanded="true" [attr.aria-controls]="'collapseOne'+l.LabType">
                          {{l.Specimen}}
                        </button>
                      </h5>
                    </div>
                    <div class="col-md-8 padding-right-4pe">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                      <button (click)="SpecimenDetails(l)" class="btn actions-btn-prime font-size-13px  float-right" *ngIf="candisplayspe"><i class="fas fa-plus font-size-11 margin-right-3px"></i> Collect Specimen</button>
                      <a class="nav-link-hand education-navlink data-color-new float-right margin-top-5px" (click)="specimen(l)" title="print">
                        <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                      </a>
                    </div>
                  </div>


                </div>

                <div [id]="'collapseOne'+l.LabType" class="collapse show" [attr.aria-labelledby]="'headingOne'+l.LabType" [attr.data-parent]="'#accordionExample'+l.LabType">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                    <div class="row margin-left-20p padding-all-5px margin-right-20p backspe">
                      <div class="col-md-4 padding-right-0px" *ngFor="let d of GetItems(l.LabType); trackBy: trackByTest">
                        <label class="margin-bottom-0px font-size-14 color-Assign font-weight-bold d-inline-flex align-items-center cursor-pointer" style="cursor: pointer; user-select: none;">
                          <input type="checkbox" class="width-23px height-16px margin-right-5px" [(ngModel)]="d.IsSelected" [ngModelOptions]="{standalone: true}" (change)="onSubmit2($event)" (ngModelChange)="onSubmit2($event)" style="cursor: pointer;" />
                          <span>{{d.TestName}}</span>
                        </label>
                      </div>

                    </div>
                    <div class="row col-md-11 margin-top-13px">
                      <div class="col-md-12">
                        <div class="table-component">
                          <div class="table-responsive overflow-x">


                            <table class="table table-striped margin-left-20p table-fixed"
                                   cols="auto,2*,*,*,*,*,*,*">

                              <thead class="">
                                <tr>





                                  <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-5px">
                                    Code
                                  </th>
                                  <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-2px">
                                    Date &amp; Time
                                  </th>
                                  <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px padding-left-10px">
                                    Tests
                                  </th>
                                  <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px padding-left-0px">
                                    Volume
                                  </th>
                                  <th class="padding-top-4px padding-bottom-4px th-sticky">
                                    Method
                                  </th>
                                  <!--<th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                    Testkit
                                  </th>
                                  <th class="padding-top-4px padding-bottom-4px th-sticky">
                                    Status
                                  </th>-->
                                  <!--<th class="">

                                  </th>-->
                                  <!--<th class="padding-top-4px padding-bottom-4px th-sticky">
                                    Submit
                                  </th>
                                  <th class="padding-top-4px padding-bottom-4px th-sticky">
                                    Receive
                                  </th>-->


                                  <th class="padding-top-4px padding-bottom-4px th-sticky">

                                  </th>


                                </tr>
                              </thead>

                              <tbody class="table-body">
                                <tr *ngFor="let m of GetSpecimen(l.Specimen); trackBy: trackBySpecimenCode">




                                  <td class="td-padding-tb padding-right-0px padding-left-5px">{{m.SpecimenFormattedCode}}</td>
                                  <td class="td-padding-tb padding-right-0px padding-left-3px">{{m.RecievedOn| date:'MMM-dd-yyyy'}} &amp; {{m.RecievedOn| date: 'hh:mm a'}}</td>
                                  <td class="td-padding-tb">{{m.TestsName}}</td>
                                  <td class="text-align-center td-padding-tb padding-left-0px">{{m.SpecimenCollectionAmount}}{{m.SpecimenCollectionUOM}}</td>
                                  <td class="td-padding-tb">{{m.CollectionMethod}}</td>




                                  <!--<td class="td-padding-tb text-align-center padding-right-0px padding-left-10px"> </td>
                                  <td class="text-align-center td-padding-tb"></td>-->
                                  <!--<td class=" td-padding-tb text-align-center">
                                    <input type="checkbox" class="width-23px height-16px margin-top-3px" />
                                    <i class="input-helper"></i>
                                  </td>
                                  <td class=" td-padding-tb text-align-center">
                                    <input type="checkbox" class="width-23px height-16px margin-top-3px" />
                                    <i class="input-helper"></i>
                                  </td>-->
                                  <td class=" td-padding-tb ">
                                    <a (click)="SpecimenDetails2(m)" class="nav-link-hand education-navlink  color-Assign" title="Edit">
                                      <span class="badge"><i class="fas fa-pencil-alt nav-link-hand"></i></span>
                                    </a>
                                    <a (click)="del_(m)" class="nav-link-hand font-size-14" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>


                                  </td>

                                </tr>
                              </tbody>



                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!--<div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div class="card">


            <div class="card-header wh-header border-bottom padding-bottom-0px">
              <div class="row border-bottom">
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount : </label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount(%) :</label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Total :</label>
                </div>
              </div>
            </div>






          </div>
        </div>
      </div>-->




    </div>
  </div>




</div>
